import Api from "../../app/api";
import { loginAuth } from "../../app/auth";
import { useDispatch } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import { useState, useEffect, useCallback } from "react";

export default function SettingProfile({ auth, setVisibleModal }) {
    const dispatch = useDispatch();
    const [token, setToken] = useState("");
    const [authData, setAuthData] = useState("");
    const [name, setName] = useState(auth?.auth_data?.name);
    const [email, setEmail] = useState(auth?.auth_data?.email);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmationPassword, setConfirmationPassword] = useState("");

    useEffect(() => {
        if (auth) {
            setToken(auth?.access_token);
            setAuthData(auth?.auth_data);
        }
    }, [auth]);

    const handleUpdateProfile = useCallback(() => {
        if (newPassword !== confirmationPassword) {
            alert("กรุณากรอกรหัสผ่านใหม่ให้ตรงกัน");
        }

        if (newPassword && newPassword.toString().length < 8) {
            alert("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร");
        }

        const formData = new FormData();
        formData.append("name", name);

        if (oldPassword && newPassword) {
            formData.append("current_password", oldPassword);
            formData.append("password", newPassword);
            formData.append("password_confirmation", confirmationPassword);
        }

        Api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        Api.post("/auth/update", formData)
            .then((response) => {
                const data = response.data;
                if (data.message === "PASSWORD_NOT_MATCH") {
                    alert("รหัสผ่านปัจจุบันไม่ถูกต้อง");
                }

                const responseData = {
                    access_token: token,
                    auth_data: data,
                };

                dispatch(loginAuth(responseData));
                setVisibleModal(false);
            })
            .catch((err) => console.log(err.messages ?? err.message));
    }, [name, oldPassword, newPassword, confirmationPassword, authData]);

    return (
        <div className="p-3">
            <div className="d-flex justify-content-between flex-nowrap align-items-center">
                <div className="h3 fw-bold mt-2">ตั้งค่าโปรไฟล์</div>
                <div>
                    <AiOutlineClose style={{ fontSize: 22, cursor: "pointer" }} onClick={() => setVisibleModal(false)} />
                </div>
            </div>
            <hr />
            <form onSubmit={handleUpdateProfile}>
                <div>
                    <label className="fw-bold my-3" htmlFor="email">
                        อีเมล
                    </label>
                    <input className="form-control" value={email} type="email" disabled onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div>
                    <label className="fw-bold my-3" htmlFor="name">
                        ชื่อ-นามสกุล
                    </label>
                    <input className="form-control" value={name} type="text" onChange={(e) => setName(e.target.value)} />
                </div>
                <div>
                    <label className="fw-bold my-3">
                        หน่วยงาน
                    </label>
                    <input className="form-control" value={auth?.auth_data?.department ?? '-'} disabled />
                </div>
                <div className="fw-bold mt-4">ตั้งค่ารหัสผ่านใหม่</div>
                <div className="my-3">
                    <input
                        className="form-control"
                        type="password"
                        placeholder="รหัสผ่านปัจจุบัน"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                    />
                </div>
                <div className="my-3">
                    <input
                        className="form-control"
                        type="password"
                        placeholder="รหัสผ่านใหม่"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                </div>
                <div className="my-3">
                    <input
                        className="form-control"
                        type="password"
                        placeholder="ยืนยันรหัสผ่านใหม่"
                        onChange={(e) => setConfirmationPassword(e.target.value)}
                    />
                </div>

                <div className="mt-3 text-end">
                    <button type="button" onClick={() => handleUpdateProfile()} className="btn btn-primary">
                        บันทึกการเปลี่ยนแปลง
                    </button>
                </div>
            </form>
        </div>
    );
}
